import React from 'react';

const Author = () => {
  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12">
      <div className="container mx-auto max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-16 text-center">
          Die Outeur
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div className="md:col-span-1 flex justify-center items-start">
            <div className="w-48 bg-surface border-r-4 border-r-[#D6D0C4] shadow-lg overflow-hidden">
              <img
                src="/author-francois-muller.jpg"
                alt="Francois Muller"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>

          <div className="md:col-span-2 space-y-6 font-body text-lg leading-loose text-charcoal">
            <p className="font-heading text-2xl italic text-muted-charcoal">
              Francois Muller is 'n sakeman, navorser en skrywer met 'n diep belangstelling 
              in ons land se geskiedenis en godsdiens.
            </p>
            <p>
              Ek is in 1964 in Evander gebore en het in Springs grootgeword, waar ek aan die 
              Hoër Seunskool Hugenote gematrikuleer het. Ná skool het ek twee jaar nasionale 
              diensplig voltooi by 1 Valskermbataljon in Bloemfontein en in SWA. Daarna het 
              ek meganiese ingenieurswese studeer en later by Eskom en Highveld Steel gewerk.
            </p>
            <p>
              In 1989 is ek en Annelie getroud en ons is geseën met 3 kinders. In 1991 het ons, 
              ons eie data-analise-onderneming begin, gefokus op die monitering van voertuie se 
              bewegings, produktiwiteit en kostes. Die besigheid is vanjaar 34 jaar oud.
            </p>
            <p>
              Ek het nog altyd 'n diep belangstelling in die geskiedenis van ons voorvaders en 
              van ons land gehad. Deur die jare het ek wyd daaroor gelees en verskeie monumente 
              en slagvelde besoek.
            </p>
            <p>
              Ek stel ook belang in godsdiens en politiek — iets wat as't ware in ons familie 
              se are vloei sedert my oupagrootjie in die 1910 Unie-parlement gedien het. Ek is 
              in murg en been 'n Afrikaner, maar bo alles beskou ek myself eerstens as 'n burger 
              van my hemelse Vader se koninkryk.
            </p>
          </div>
        </div>

        <div className="border-t border-charcoal/10 pt-12">
          <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal text-center">
            Outeur se Nota
          </h2>
          <blockquote className="font-body text-xl leading-relaxed text-center italic text-muted-charcoal max-w-3xl mx-auto">
            "Die doel van hierdie dokument is nie om kwaadwillig te wees en iemand of 'n groep 
            mense te verneder of vingers te wys nie, maar om die waarheid aan die lig te bring 
            en aan ons God (YHWH) gehoorsaam te wees."
          </blockquote>
          <p className="text-center mt-8 font-ui text-sm uppercase tracking-widest text-charcoal">
            — Francois Muller
          </p>
        </div>
      </div>
    </div>
  );
};

export default Author;
